<template>
    <div>
        <div class="">
            <div class="faq-wrap">
                <div class="card-box"
                    style="padding-left: 20px;padding-right: 20px;padding-bottom: 10px;padding-top: 20px;">
                    <div class="card-header">
                        <div class="clearfix">
                            <div class="pull-left">
                                <h4 class="text-black h4">Cadastro tipos de usuário</h4>
                            </div>
                        </div>
                    </div>
                    <v-form>
                        <v-container>
                            <v-row>
                                <v-col cols="12" md="4" v-show="false">
                                    <v-text-field v-model="TipoUsuario.tusId" label="Id" variant="underlined"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="TipoUsuario.tusNome" :rules="nameRules" :counter="100"
                                        label="Nome Tipo" variant="underlined" required></v-text-field>
                                </v-col>

                                <v-col cols="12" md="4">
                                    <v-select v-model="TipoUsuario.tusVisivel" label="Visível" :items="StatusVisivel"
                                        item-title="nome" item-value="tusVisivel" variant="underlined">
                                    </v-select>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-select v-model="TipoUsuario.tusAtivo" label="Ativo" :items="StatusAtivo"
                                        item-title="nome" item-value="tusAtivo" variant="underlined">
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                    <form>
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <button type="button" @click="Limpar()" class="btn btn-link">
                                    Cancelar
                                </button>
                                <button v-if="TipoUsuario.tusId != 0" type="button" class="btn btn-success" @click="Put()">
                                    Alterar
                                </button>
                                <button v-else type="button" class="btn btn-success" @click="Add()">
                                    Salvar
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="">
            <div class="faq-wrap">
                <div class="card-box" style="padding-left: 20px;padding-right: 20px;padding-bottom: 10px;margin-top: 20px;">
                    <v-container>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="searchValue" label="Pesquisa" variant="underlined"
                                    required></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                    <easy-data-table :headers="headers" :items="TipoUsuarios" v-model="itemsSelected" alternating
                        theme-color="#364f66" table-class-name="customize-table" header-text-direction="center"
                        body-text-direction="center" rows-per-page-message="Linhas por pagina" :search-value="searchValue">
                        <template #item-tusVisivel="item">
                            <span>{{ item.tusVisivel ? 'Sim' : 'Não' }}</span>
                        </template>
                        <template #item-tusAtivo="item">
                            <span>{{ item.tusAtivo ? 'Sim' : 'Não' }}</span>
                        </template>
                        <template #item-actions="item">
                            <v-btn icon @click="EditGrid(item)" style="margin-right: 10px;" variant="text">
                                <v-icon>mdi-file-edit-outline</v-icon>
                                <v-tooltip activator="parent" location="top">Editar</v-tooltip>
                            </v-btn>

                            <v-btn icon @click="DeleteGrid(item)" variant="text">
                                <v-icon>mdi-delete-forever-outline</v-icon>
                                <v-tooltip activator="parent" location="top">Excluir</v-tooltip>
                            </v-btn>
                        </template>
                    </easy-data-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
export default {
    name: 'CadastroTipoUsuarioView',
    components: {
        EasyDataTable
    },
    data: () => ({
        TipoUsuario: {
            tusId: 0,
            tusNome: '',
            tusVisivel: '',
            tusAtivo: '',
        },
        TipoUsuarios: [],
        selectedVisivel: null,
        StatusVisivel: [{ nome: "Sim", tusVisivel: true }, { nome: "Não", tusVisivel: false }],
        StatusAtivo: [{ nome: "Sim", tusAtivo: true }, { nome: "Não", tusAtivo: false }],
        nameRules: [
            value => {
                if (value?.length <= 100) return true
                return 'Nome pode conter até 100 caracteres.'
            },
        ],

        headers: [
            { text: "Id", value: "tusId", sortable: true, },
            { text: "Nome", value: "tusNome", sortable: true, },
            { text: "Visivel", value: "tusVisivel", sortable: true, },
            { text: "Ativo", value: "tusAtivo", sortable: true, },
            { text: 'Ações', value: 'actions' }
        ],
        itemsSelected: [],
        selectedItem: null,
        searchValue: '',
    }),
    methods: {
        Limpar() {
            this.TipoUsuario.tusId = 0;
            this.TipoUsuario.tusNome = '';
            this.TipoUsuario.tusVisivel = '';
            this.TipoUsuario.tusAtivo = '';
            this.selectedVisivel = '';
            this.Get();
        },
        Add() {
            if (this.TipoUsuario.tusNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.TipoUsuario.tusVisivel === ''){
                this.$mensagemAviso("Visível Obrigatório.")
            }
            else if (this.TipoUsuario.tusAtivo === ''){
                this.$mensagemAviso("Ativo Obrigatório.")
            }
            else {
                axios.post(`/Process/AdmTipoUsuario/Add`, this.TipoUsuario)
                    .then(response => {
                        if (response.data > 0) {
                            this.$mensagemAvisoSucesso("Registro Incluído.")
                            this.Get();
                            this.Limpar();
                        }
                    });
            }
        },
        Put() {
            if (this.TipoUsuario.tusNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.TipoUsuario.tusVisivel === ''){
                this.$mensagemAviso("Visível Obrigatório.")
            }
            else if (this.TipoUsuario.tusAtivo === ''){
                this.$mensagemAviso("Ativo Obrigatório.")
            }
            else {
                axios.put(`/Process/AdmTipoUsuario/Update`, this.TipoUsuario)
                    .then(response => {
                        if (response.status == 200) {
                            this.$mensagemAvisoSucesso("Registro Alterado.")
                            this.Get();
                            this.Limpar();
                        }
                    });
            }
        },
        EditGrid(item) {
            // Lógica para editar o item
            this.TipoUsuario = item;
            this.$scrollToTop();
        },
        DeleteGrid(item) {

            this.$mensagemConfirma('Tem certeza que deseja excluir?')
            .then((result) => {
            if (result.isConfirmed) {
                // Lógica para excluir o item
                const param1 = item.tusId;
                axios.delete(`/Process/AdmTipoUsuario/Delete/${param1}`)
                .then(response => {
                    if (response.status == 200) {
                        this.$mensagemAvisoSucesso("Registro Excluido.")
                        this.Get();
                        this.Limpar();
                    }
                });
            }
            });
        },
        Get() {
            axios.get(`/Process/AdmTipoUsuario/GetAll`)
                .then(response => {
                    this.TipoUsuarios = response.data;
                });
        }
    },
    created() {
        this.Get();
    },
}
</script>

<style></style>
